import { AccountTokenType } from "@eisox/api/core-api";
import { ActionButton, UnprotectedRouteResponsiveCard } from "@eisox/design-system";
import { ArrowRightIcon } from "@eisox/icons";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";

import { accountApi } from "~/api";
import { loadInvalidTokenContext } from "~/features/account";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/used-token")({
  validateSearch: search => ({ token: (search.token as string) || "" }),
  loaderDeps: ({ search: { token } }) => ({ token }),
  loader: ({ context: { queryClient }, deps: { token } }) => loadInvalidTokenContext(queryClient, token),
  component: RouteComponent,
});

function RouteComponent() {
  const { type, email } = Route.useLoaderData();
  const navigate = Route.useNavigate();

  // The account is already activated, so recovery from here can only mean a password reset.
  const { mutate: sendResetLink } = useMutation({
    meta: { toast: { success: m.account_email_sent() } },
    mutationFn: () => accountApi.requestPasswordReset(email),
    onSuccess: async () => {
      await navigate({ to: "/sign-in", search: { redirect: "" } });
    },
  });

  return (
    <UnprotectedRouteResponsiveCard version={import.meta.env.VITE_VERSION}>
      <div className="gap-y-10 flex flex-col items-center" data-testid="UsedToken">
        <p className="max-w-91.25 text-base whitespace-pre-line text-primary-dark-blue">{m[`used_token_${type}`]()}</p>
        <div className="gap-5 md:flex-row flex flex-col items-center justify-center">
          {type === AccountTokenType.ACCOUNT && (
            <ActionButton onClick={() => sendResetLink()}>
              {m.reset_password()}
              <ArrowRightIcon />
            </ActionButton>
          )}
          <ActionButton asChild>
            <Link to="/sign-in" search={{ redirect: "" }}>
              {m.sign_in()}
              <ArrowRightIcon />
            </Link>
          </ActionButton>
        </div>
      </div>
    </UnprotectedRouteResponsiveCard>
  );
}
